
function inputRichTextLinkDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/input-rich-text-link/input-rich-text-link-dialog.html?$$REVISION$$'
  }
}
export { inputRichTextLinkDialog }
